// @ts-strict-ignore
import {
  RouteComponentProps as ReactRouterRouteComponentProps,
  useHistory,
  useLocation,
} from 'react-router-dom';

// This implementation of withRouter is there only to upgrade
// react-router, since they stopped providing it and only the
// hooks available now. We needed it to support class based
// components that have not been re-written yet.
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const history = useHistory();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} location={location} history={history} />;
  }

  return ComponentWithRouterProp;
}

export type RouteComponentProps = {
  location: ReactRouterRouteComponentProps['location'];
  history: ReactRouterRouteComponentProps['history'];
};
